exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-cart[data-v-72c1d524]{width:100%;height:200px;object-fit:contain;object-position:center}.buttons[data-v-72c1d524]{margin:25px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72c1d524","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/app/manager/histories/insert.vue
// module id = 303
// module chunks = 0